import {
	getColor,
	getGradient,
	getSize,
	getWeight,
} from "views/resources/theme";
import styled from "styled-components";

export const Wrapper = styled.div`
	background: ${getGradient("default")};
	h1,
	p {
		text-align: center;
		color: ${getColor("fg_alt")};
	}
`;

export const TopBarWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	background-color: ${getColor("bg_alt")};

	a {
		text-size: ${getSize("m")};
		text-weight: ${getWeight("medium")};
		color: ${getColor("primary")};
		padding: ${getSize("m")} ${getSize("l")};
	}

	a.selected {
		border-bottom: 2px solid ${getColor("primary")};
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: ${getSize("m")} 0;
	background-color: ${getColor("bg")};

	h1 {
		color: ${getColor("fg")};
	}
`;
